module.exports = __webpack_public_path__ + "img/icons8-link-24.c549d321.svg";